export enum SettingCategories {
  GENERAL = "General",
  CALCULATOR = "Calculator",
  COMPANY_SETTING = "CompanySettings",
  CUSTOM_SETTING = "CustomSettings",
  DIGITAL_SIGNATURE = "DigitalSignature",
  CONTRACT_ACCOUNTS = "ContractAccounts",
}
